import { SvgIcon } from "@mui/material";
import React from "react";

function RefferalsIcon(props) {
  return (
    <SvgIcon viewBox="0 0 22 22" {...props}>
      <path
        d="M10.9999 20.1654C16.0625 20.1654 20.1666 16.0613 20.1666 10.9987C20.1666 5.93609 16.0625 1.83203 10.9999 1.83203C5.93731 1.83203 1.83325 5.93609 1.83325 10.9987C1.83325 16.0613 5.93731 20.1654 10.9999 20.1654Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.34253 13.3C7.50753 13.575 7.70919 13.8317 7.93836 14.0608C9.62502 15.7475 12.3659 15.7475 14.0617 14.0608C14.7492 13.3733 15.1434 12.5024 15.2717 11.6133"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.72827 10.3844C6.8566 9.48608 7.25078 8.62438 7.93828 7.93688C9.62494 6.25021 12.3658 6.25021 14.0616 7.93688C14.2999 8.17521 14.4924 8.43189 14.6574 8.69772"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.16821 15.7483V13.3008H9.6157"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8315 6.25V8.69748H12.384"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default RefferalsIcon;
